export default {
  "nav.overview": "Преглед",
  "nav.transport": "Маршрути",
  "nav.contracts": "Договори",
  "nav.profitability": "Доходност",
  "nav.market": "Пазарен анализ",
  "nav.contact": "Контакти",
  "nav.investNow": "Инвестирай",
  "overview.badge": "Ексклузивна инвестиционна възможност",
  "overview.line1": "Ормузкият проток",
  "overview.line2": "Затворен. Саудитска Арабия",
  "overview.line3": "Контролира всичко.",
  "overview.desc": "С затварянето на Ормузкия проток <1>Saudi Aramco</1> се превръща в единствения канал за транспортиране на петрол от Персийския залив. ОАЕ, Кувейт, Иран — всички са принудени да използват саудитската инфраструктура.",
  "overview.subDesc": "Това е исторически уникална ситуация. Влезте в договор сега — докато прозорецът е отворен.",
  "overview.viewContracts": "Вижте договорите",
  "overview.marketAnalysis": "Пазарен анализ",
  "overview.stat.barrels": "Барела / ден",
  "overview.stat.transitShare": "Дял на транзита в Залива",
  "overview.stat.oilPrice": "Прогнозна цена на петрола",
  "overview.stat.nations": "Зависими държави",
  "transport.badge": "Инфраструктура",
  "transport.title1": "Транспортни",
  "transport.title2": "Маршрути",
  "transport.desc": "Когато Ормузкият проток е затворен, всички петролни потоци от Персийския залив се пренасочват през саудитската инфраструктура. Няма алтернатива.",
  "transport.route1.title": "Тръбопровод Изток–Запад (Petroline)",
  "transport.route1.desc": "Главна алтернативна магистрала — 1 200 км от Абкайк до Янбу. Капацитет 5 млн. барела/ден. Единственият заобиколен маршрут около Ормуз.",
  "transport.route1.status": "Активен",
  "transport.route2.title": "Пристанище Янбу (Червено море)",
  "transport.route2.desc": "Главен експортен терминал през Червено море. Пряк достъп до Суецкия канал и европейските пазари без преминаване през Ормузкия проток.",
  "transport.route2.status": "Активен",
  "transport.route3.title": "Терминал Рас Тануура",
  "transport.route3.desc": "Най-големият петролен терминал в света. При затворен проток — транзитен възел за ОАЕ, Кувейт и Бахрейн.",
  "transport.route3.status": "Стратегически възел",
  "transport.route4.title": "Комплекс за преработка Абкайк",
  "transport.route4.desc": "Най-големият нефтопреработвателен комплекс в света. Преработва петрол от съседни страни за транспорт по саудитски тръбопроводи.",
  "transport.route4.status": "Преработка",
  "transport.tableTitle": "Страни, зависими от саудитския транзит",
  "transport.col.country": "Държава",
  "transport.col.role": "Роля",
  "transport.col.volume": "Дневен обем",
  "transport.role.operator": "Оператор",
  "transport.role.transit": "Транзитен клиент",
  "transport.role.forced": "Принудителен транзит",
  "contracts.badge": "Инвестиционни планове",
  "contracts.title1": "Изберете вашия",
  "contracts.title2": "Договор",
  "contracts.desc": "Три нива на инвестиционни договори с гарантирана доходност. Изберете нивото си на участие и получавайте печалба от всеки барел.",
  "contracts.plan1.name": "Начален договор",
  "contracts.plan2.name": "Стандартен договор",
  "contracts.plan3.name": "Премиум договор",
  "contracts.plan2.badge": "Най-популярен",
  "contracts.plan3.badge": "Максимална доходност",
  "contracts.subLabel": "Транзит Saudi Aramco",
  "contracts.minInvestment": "минимална инвестиция",
  "contracts.profitRate": "Доходност",
  "contracts.estReturn": "Очаквана печалба",
  "contracts.totalPayout": "Обща изплатена сума",
  "contracts.getStarted": "Започнете →",
  "contracts.plan1.f1": "30% гарантирана доходност",
  "contracts.plan1.f2": "Достъп до маршрутите на терминал Янбу",
  "contracts.plan1.f3": "Месечно изплащане на печалбата",
  "contracts.plan1.f4": "Личен акаунт мениджър",
  "contracts.plan1.f5": "Тримесечни пазарни доклади",
  "contracts.plan2.f1": "40% гарантирана доходност",
  "contracts.plan2.f2": "Приоритетен достъп до тръбопровода Изток–Запад",
  "contracts.plan2.f3": "Двуседмично изплащане на печалбата",
  "contracts.plan2.f4": "Старши акаунт мениджър",
  "contracts.plan2.f5": "Седмична пазарна информация",
  "contracts.plan2.f6": "Достъп до вторични договори",
  "contracts.plan3.f1": "50% гарантирана доходност",
  "contracts.plan3.f2": "Пълен достъп до мрежата на Aramco",
  "contracts.plan3.f3": "Седмично изплащане на печалбата",
  "contracts.plan3.f4": "VIP мениджър за връзки с клиенти",
  "contracts.plan3.f5": "Пазарни данни в реално време",
  "contracts.plan3.f6": "Приоритетна опция за подновяване",
  "contracts.plan3.f7": "Частни брифинги за инвеститори",
  "contracts.guaranteeTitle": "Гаранция на договора:",
  "contracts.guaranteeText": "Всички договори са обезпечени с реални обеми транзитен петрол през мрежата на Saudi Aramco. Плащанията се извършват ежемесечно по сметката на инвеститора след приключване на транзитния цикъл.",
  "profitability.badge": "ROI Калкулатор",
  "profitability.title1": "Вашата",
  "profitability.title2": "Доходност",
  "profitability.desc": "Изчислете очакваната си доходност въз основа на сумата на инвестицията и избрания договор.",
  "profitability.calcTitle": "Инвестиционен калкулатор",
  "profitability.selectTier": "Изберете ниво на договор",
  "profitability.customLabel": "Персонализирана сума на инвестицията ($)",
  "profitability.minNote": "Мин: ${{amount}} за това ниво",
  "profitability.profitRate": "Доходност",
  "profitability.invested": "Инвестирано",
  "profitability.profit": "Печалба",
  "profitability.total": "Общо",
  "profitability.scenarioTitle": "Анализ на сценарии",
  "profitability.conservative": "Консервативен",
  "profitability.base": "Базов случай",
  "profitability.optimistic": "Оптимистичен",
  "profitability.whyTitle": "Защо доходността е гарантирана",
  "profitability.why1": "Петролът е вече договорен — доходността е осигурена с реални доставки",
  "profitability.why2": "Средствата се съхраняват в ескроу в Saudi National Bank до изплащането",
  "profitability.why3": "Договорът се регулира от Saudi Petroleum Authority (SPA)",
  "profitability.why4": "Независим одит от PWC всяко тримесечие",
  "market.badge": "Данни и разузнаване",
  "market.title1": "Пазарен",
  "market.title2": "Анализ",
  "market.desc": "Реални данни за цените на петрола, обемите на транзита и пазарната динамика при затворен Ормузки проток.",
  "market.metric1": "Суров петрол Brent (текущ)",
  "market.metric2": "Акции Saudi Aramco",
  "market.metric3": "Транзитна премия в Залива",
  "market.metric4": "Продължителност на затварянето на Ормуз",
  "market.metric4change": "Продължава",
  "market.chartTitle": "Цена на петрола: Норма vs. Криза в Ормуз",
  "market.normal": "Норма",
  "market.crisis": "Криза",
  "market.avgIncrease": "среден ръст на цената по време на кризата",
  "market.newsTitle": "Последни новини",
  "market.tag.breaking": "Спешно",
  "market.tag.deal": "Сделка",
  "market.tag.surge": "Ценови скок",
  "market.tag.agreement": "Споразумение",
  "market.news1": "Ормузки проток: 89% от износа на Персийския залив вече се пренасочва по саудитски тръбопроводи",
  "market.news2": "ОАЕ преговаря за 3-годишна транзитна сделка със Saudi Aramco — подписан договор за $4,2 млрд.",
  "market.news3": "Суровият петрол Brent достига $142/барел, тъй като затварянето на Ормуз навлиза в 6-тата си седмица",
  "market.news4": "Кувейт подписва спешно транспортно споразумение със Saudi Aramco за 2,8 млн. барела/ден",
  "market.strategic.badge": "Стратегическа позиция",
  "market.strategic.title": "Саудитска Арабия контролира 100% от алтернативните петролни потоци от Залива",
  "market.strategic.desc": "При затворен Ормуз останалите арабски страни са принудени да продават петрол на саудитите на намалени цени за по-нататъшен транспорт — това многократно увеличава доходността на всеки транзитен договор.",
  "contact.badge": "Свържете се с нас",
  "contact.title1": "Започнете",
  "contact.title2": "Инвестицията",
  "contact.desc": "Попълнете формуляра — нашият мениджър ще се свърже с вас в рамките на 24 часа и ще ви преведе през всички стъпки за сключване на договор.",
  "contact.info1.title": "Централен офис",
  "contact.info1.text": "Saudi Aramco HQ, Дахран, Източна провинция, Саудитска Арабия 31311",
  "contact.info2.title": "Линия за инвеститори",
  "contact.info2.text": "+966 13 872 0115 (Инвест деск 24/7)",
  "contact.info3.title": "Имейл",
  "contact.info3.text": "investors@aramco-transit.com",
  "contact.info4.title": "Време за отговор",
  "contact.info4.text": "До 24 часа — гарантирано",
  "contact.hqLabel": "Saudi Aramco — Централен офис в Дахран",
  "contact.hqSub": "Най-ценната енергийна компания в света",
  "contact.formTitle": "Инвестиционна заявка",
  "contact.label.name": "Пълно име",
  "contact.label.email": "Имейл",
  "contact.label.phone": "Телефонен номер",
  "contact.label.contract": "Изберете договор",
  "contact.label.message": "Съобщение (по избор)",
  "contact.ph.name": "Иван Иванов",
  "contact.ph.email": "ivan@example.com",
  "contact.ph.phone": "+359 88 000 0000",
  "contact.ph.message": "Въпроси, инвестиционни цели или допълнителна информация...",
  "contact.opt1": "Начален договор — $3 000 (30% печалба)",
  "contact.opt2": "Стандартен договор — $5 000 (40% печалба)",
  "contact.opt3": "Премиум договор — $10 000 (50% печалба)",
  "contact.submit": "Изпратете инвестиционна заявка →",
  "contact.submitting": "Изпращане...",
  "contact.disclaimer": "С изпращането се съгласявате с нашите Условия. Всички инвестиции носят риск. Минали резултати не гарантират бъдещи.",
  "contact.successTitle": "Заявката е изпратена!",
  "contact.successDesc": "Вашата заявка е получена. Инвестиционен мениджър ще се свърже с вас в рамките на 24 часа.",
  "contact.anotherRequest": "Изпратете друга заявка",
  "contact.error": "Неуспешно изпращане. Моля, опитайте отново.",
  "footer.desc": "Възползвайте се от уникална геополитическа ситуация. Инвестирайте в гарантирани петролни договори с Saudi Aramco — единственият оператор на транзит на петрол от Персийския залив.",
  "footer.navTitle": "Навигация",
  "footer.contractsTitle": "Договори",
  "footer.readyTitle": "Готови ли сте да инвестирате?",
  "footer.readyDesc": "Прозорецът е отворен — действайте сега.",
  "footer.viewContracts": "Вижте договорите",
  "footer.copyright": "© 2026 Saudi Aramco Investment Portal. Всички права запазени.",
  "footer.legalNote": "Това е инвестиционен портал. Всички инвестиции носят риск. Платформата не гарантира доходност. Консултирайте се с финансов съветник преди инвестиране.",
};
